/**
 * The page's one drainer, and the one store and transport behind it.
 *
 * Constructed at module load but touching nothing until first used: `IndexedDbEventStore`
 * opens its database lazily, so importing this in a browser that cannot persist is harmless
 * and the app's own `canPersist` gate still decides what the scorer sees.
 *
 * Both the scoring screen and the app-level foreground drain use these, so there is exactly
 * one `Outbox` per match in the page. The service worker builds its own from the same parts
 * (a worker cannot share this instance) and the two coordinate through `navigator.locks`.
 */
import { Drainer } from "@sportsos/sync";
import { currentUserId } from "../identity.ts";
import { IndexedDbEventStore } from "../storage/indexeddb.ts";
import { HttpTransport } from "../storage/transport.ts";
import { lockRunner, platformLocks } from "./locks.ts";

export const eventStore = new IndexedDbEventStore({ writtenBy: currentUserId });

export const drainer = new Drainer({
  store: eventStore,
  transport: new HttpTransport(),
  withLock: lockRunner(platformLocks()),
  owner: currentUserId,
  // Never send a ball that has an owner while nobody is known to be signed in.
  ownerRequired: true,
});
